import axios from 'axios'


const whiteUrl = ['/api/oms/uploadBookInfo/uploadBookCheck']
//过滤请求
let isRefreshing = false
const service = axios.create({
  baseURL: 'https://api.duikanapp.cn:9999/chat_app',
  timeout: 30000 // request timeout
});
service.interceptors.request.use(config => {
  
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(response => {
  // console.log(response)
  // console.log(Reflect.has(response.data, 'code'))
  console.log(response)
return response
}, error => {
  // 捕获服务器返回的状态码
  if (error && error.response) {
    return Promise.reject(error)
  }
  // 捕获设置的超时时间
  if (error.message.includes('timeout')) {
    // Notification({ type: 'error', title: '错误', message: '网络超时' })
    return Promise.reject(error)
  }
  return Promise.reject(error)
}
)
// 请求方法
export default function request (method, url, data = {}, option = { requestType: null, responseType: null, requestField: null }) {
  let type = '' //请求类型  requestType为表单 反之为json 默认不传 请求类型是json需要传递
  let httpData = null
  if (!option.requestType) {
    httpData = data
    type = 'application/json'
  } else {
    httpData = data
    type = 'application/x-www-form-urlencoded'
  }
  method = method.toLocaleLowerCase()
  if (method === 'post') {
    return service.post(url, httpData, { headers: { 'Content-Type': type }, responseType: option?option.responseType:'' })
  } else if (method === 'put') {
    return service.put(url, httpData, { headers: { 'Content-Type': type } })
  } else if (method === 'get') {
    return service.get(url, {
      params: data
    },
      { headers: { 'Content-Type': type } }
    )
  } else if (method === 'delete') {
    return service.delete(url, {
      params: { type: 'get', data },
    },
      { headers: { 'Content-Type': type } }
    )
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js